import React from "react";
import Footer from "../components/footer/footer";
import NewFooter from "../views/pages/facelifting/newFooter";

const MainLayout = ({ children, hideFooter = false, ...rest }) => {
  //  console.log("value",children)
  return (
    <div>
      {children}
      {!hideFooter && (
        <div className>
          <NewFooter></NewFooter>
        </div>
      )}
    </div>
  );
};
export default MainLayout;
